import { z } from 'zod';

import { RTESchema } from './RTE';
import { ImageSchema } from './Image';
import { FileSchema } from '../types/File.schema';
import { CompanyProfileSchema } from './CompanyProfile';

const ArticleSchema = z.object({
    id: z.string().optional(),
    type: z.enum(['caseStudy', 'promotion']),
    name: z.string().min(3).default(''),
    shortName: z.string().optional(),
    file: z
        .union([z.string(), FileSchema.nullable().default(null)])
        .optional()
        .nullable(),
    teaser: z.object({
        image: z
            .union([z.string(), ImageSchema.nullable().default(null)])
            .optional()
            .nullable(),
        description: RTESchema.optional().nullable(),
        shortDescription: z.string().optional(),
        button: z
            .object({
                label: z.string().optional().nullable(),
                url: z.string().url().optional().nullable(),
            })
            .optional()
            .nullable(),
    }),
    images: z.array(z.union([z.string(), ImageSchema.nullable().default(null)])).optional(),
    company: z.union([z.string(), CompanyProfileSchema]),
    attributes: z
        .array(
            z.object({
                name: z.string(),
                value: z.string(),
            }),
        )
        .optional(),
});

export { ArticleSchema };
